import React, { Component } from 'react';
import {
  ColorSelectorWrapper,
  LayerStyleTitle,
  LayerStylesInfo,
  LayerStylesInfoHeader,
  LayerStylesWrapper,
  PopUpCloseBtn,
  PopUpHeader,
  PopUpTitle,
  RadioButton,
  SeparatorLine,
  StylesPopUp
} from '../../CapaLlegendaFooterElements';
import { getTranslatedKey } from '../../../../../Utils/TranslateUtils';
import { HexColorInput, HexColorPicker } from 'react-colorful';
import { createLayer } from '../../../../../Utils/MapUtils';
import { getStyle, getStyleName, getCloseIcon } from './LayerStylesUtils';
export default class LayerStyles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleSelected: 0
    };
  }

  /**
   *
   * @param iterator posicion del estilo en el array de estilos de la capa
   * @param layer capa sobre la cual se mira el estilo
   * @desc Función para checkear si el estilo con posicion iterator es el estilo seleccionado para la capa
   */
  isCurrentStyle = (iterator, layer) => {
    return layer.getStyleSelected() === iterator;
  };
  /**
   *
   * @desc Función para cambiar el estilo seleccionado al cambiar el radio button seleccionado en el selector de estilos
   */
  handleStyleChange = (event) => {
    this.setState({ styleSelected: this.props.layer.getStyleByName(event.target.value) }, () => this.onSelectStyleClick());
  };

  /**
   *
   * @desc Función para cambiar el estilo seleccionado al clickar al boton de seleccionar estilo
   */
  onSelectStyleClick = async () => {
    let opacity = this.props.layer.getOLLayer().getOpacity();
    let filter =
      this.props.taulaFullFilter[this.props.layer.getTitle()] !== undefined ? this.props.taulaFullFilter[this.props.layer.getTitle()] : undefined;
    await this.props.layer.setStyleSelected(this.state.styleSelected);
    this.props.handleStyleChanged(this.state.styleSelected);
    this.props.map.removeLayer(this.props.layer.getOLLayer());
    await createLayer(
      this.props.layer,
      this.props.map,
      this.props.arrayLayers,
      false,
      this.props.layer.getStyle(this.props.layer.getStyleSelected()).getName(),
      filter
    );
    this.props.layer.getOLLayer().setOpacity(opacity);
    this.props.layer.getOLLayer().setVisible(this.props.layer.isVisible());
    await this.props.onStyleChangeOrder();
  };

  createStyle = (styleID) => {
    this.props.layer.generateUIStyle(styleID, this.props.layer, this.update, false);
  };

  update = () => {
    this.setState({});
  };

  changeLayerStyle = async (color) => {
    let style = getStyle(color);
    if (this.props.layer.isKML()) {
      this.props.layer
        .getOLLayer()
        .getSource()
        .getFeatures()
        .forEach((feat) => {
          feat.setStyle(style);
        });
    } else {
      this.props.layer.getOLLayer().setStyle(style);
    }
  };

  render() {
    return (
      <>
        <SeparatorLine />
        {this.props.layer?.getNumStyles() > 1 ? (
          <StylesPopUp>
            <PopUpHeader>
              <PopUpTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('titleStyles')}</PopUpTitle>
              <PopUpCloseBtn title={getTranslatedKey('tancar')} onClick={() => this.props.handleCloseStyles()}>
                {getCloseIcon(this.props.fontSizeEnabled)}
              </PopUpCloseBtn>
            </PopUpHeader>
            {this.props.layer.getStyles().map((style, index) => {
              if (style.getNumRules() > 0) {
                !this.props.layer.hasRule(index) && this.createStyle(index);
                return (
                  <LayerStylesInfo id={'layerStyleInfo_' + this.props.layer.getName()} key={index}>
                    <LayerStylesInfoHeader>
                      <RadioButton
                        type="radio"
                        defaultChecked={this.isCurrentStyle(index, this.props.layer)}
                        name={'stylesSelector' + this.props.layer.getName()}
                        onChange={(event) => this.handleStyleChange(event)}
                        value={getStyleName(this.props.layer, index)}
                      />
                      <LayerStyleTitle title={getStyleName(this.props.layer, index)} fontSizeEnabled={this.props.fontSizeEnabled}>
                        {getStyleName(this.props.layer, index)}
                      </LayerStyleTitle>
                    </LayerStylesInfoHeader>
                    <LayerStylesWrapper>{this.props.layer.getRule(index)}</LayerStylesWrapper>
                  </LayerStylesInfo>
                );
              }
              return null;
            })}
          </StylesPopUp>
        ) : (
          this.props.layer?.isTemporal() && (
            <ColorSelectorWrapper className="ColorWrapper">
              <PopUpHeader>
                <PopUpTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('styleSymbol')}</PopUpTitle>
                <PopUpCloseBtn title={getTranslatedKey('tancar')} onClick={() => this.props.handleCloseStyles()}>
                  {getCloseIcon(this.props.fontSizeEnabled)}
                </PopUpCloseBtn>
              </PopUpHeader>
              {this.props.layer.isKML() && (
                <PopUpTitle style={{ marginBottom: '15px' }} fontSizeEnabled={this.props.fontSizeEnabled}>
                  {getTranslatedKey('kmlAlert')}
                </PopUpTitle>
              )}
              <HexColorPicker
                color={this.props.layer.getColor()}
                onChange={(color) => {
                  this.props.layer.setColor(color);
                  this.changeLayerStyle(color);
                  this.props.update();
                }}
              />
              <HexColorInput
                className="colorPickerInput"
                color={this.props.layer.getColor()}
                prefixed={true}
                onChange={(color) => {
                  if (color.length === 7) {
                    this.props.layer.setColor(color);
                    this.changeLayerStyle(color);
                    this.props.update();
                  }
                }}
              />
            </ColorSelectorWrapper>
          )
        )}
      </>
    );
  }
}
